import { render } from "./HomeVideoItem.vue?vue&type=template&id=94398d4e"
import script from "./HomeVideoItem.vue?vue&type=script&lang=js"
export * from "./HomeVideoItem.vue?vue&type=script&lang=js"

import "./HomeVideoItem.vue?vue&type=style&index=0&id=94398d4e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__